import React from 'react'

export default function PageNotFound() {
  return (
    <div>404 PageNotFound</div>
  )
}
